import WebFontLoader from 'webfontloader';

/**
 * WebFont
 *
 * @type {Object}
 */
const WebFont = {

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		this.loadWebFonts();
	},

	/**
	 * Load Google Fonts.
	 *
	 * @return {void}
	 */
	loadWebFonts() {

		const WebFontConfig = {
			google: {
				families: [
					'Poppins:300,400,500,600,700',
					'Questrial:400',
					'icon-zola'
				]
			}
		};

		WebFontLoader.load( WebFontConfig );

	}
};

export { WebFont };
